import { inject, InjectionToken } from "@angular/core";
import { PRODUCT_TOKEN } from "src/app/core/product.token";
import { SoftwareProduct } from "src/app/support/product";
import { environment } from "src/environments/environment";

export type AuthConfiguration = {
  region: string;
  userPoolId: string;
  userPoolWebClientId: string;
};

export const AUTH_CONFIGURATION = new InjectionToken<AuthConfiguration>(
  "auth_configuration",
  {
    providedIn: "root",
    factory: () => {
      switch (inject(PRODUCT_TOKEN)) {
        case SoftwareProduct.PMS:
        case SoftwareProduct.ROCKET:
        case SoftwareProduct.SNOOTS:
        case SoftwareProduct.ADMIN:
        case SoftwareProduct.DROP_PAGE:
        case SoftwareProduct.PLATFORM: {
          return {
            region: environment.snoots.auth.cognito.region,
            userPoolId: environment.snoots.auth.cognito.userPoolId,
            userPoolWebClientId:
              environment.snoots.auth.cognito.userPoolWebClientId
          };
        }
        case SoftwareProduct.BOTMASTER: {
          return {
            region: environment.dazerolab.auth.cognito.region,
            userPoolId: environment.dazerolab.auth.cognito.userPoolId,
            userPoolWebClientId:
              environment.dazerolab.auth.cognito.userPoolWebClientId
          };
        }
      }
    }
  }
);
